// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cnO7","tabsBox":"styles_tabsBox__1dKPZ","createButton":"styles_createButton__2QagZ"};